import store from '@/hotdesk-ui/store/store'; // Adjust the path if necessary
import { RootState } from '@/hotdesk-ui/store/store';

class GeoLocationService {
  getGeoLocationData() {
    const state: RootState = store.getState();
    return state.geoLocation.geoLocationZipData;
  }
}

export const geoLocationService = new GeoLocationService();
